import React from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { withTranslation } from "react-i18next"

import asyncActions from "./state/async-actions"
import * as actions from "./state/actions"

import {
  Button,
  Checkbox,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  MobileStepper,
  Paper,
  RadioGroup,
  Select,
  Snackbar,
  TextareaAutosize,
  TextField,
  Tooltip,
  Typography
} from "@material-ui/core"

import {
  Add,
  ChevronLeft,
  ChevronRight,
  Delete,
  ExitToApp,
  VerifiedUser
} from "@material-ui/icons"

import Alert from "@material-ui/lab/Alert"

// Hieronder componenten importeren
import HKVDialog from "./components/HKVDialog/2.0"
import HKVDrawer from "./components/HKVDrawer/1.0"
import HKVMap from "./components/HKVMap/3.0"
import HKVVega from "./components/HKVVega/3.0"

import Login from "./components/HKVFirebase/2.0/Authentication/Login"

// import { getPushTokenStatus, toggleSubscription } from "./components/HKVFirebase/2.0/Messaging/Functions"
import { doSignOut, onAuthStateChanged } from "./components/HKVFirebase/2.0/Authentication/Functions"
import { firestore } from "./components/HKVFirebase/2.0/Authentication/firebase"

import { getUploadUrl } from "./state/async-actions/mangrove"

import { makeRequest } from "./lib/utils"

import { convertFromHTML, convertToRaw, ContentState, EditorState } from "draft-js"
import htmlToDraft from "html-to-draftjs"
import { draftToMarkdown } from "markdown-draft-js"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

import SwipeableViews from "react-swipeable-views"

import { FileUploader } from "devextreme-react"

import i18n from "./i18n"

import moment from "moment"
import "moment/locale/nl"

import "./App.css"
import draftToHtml from "draftjs-to-html"

const styles = theme => ({
  container: {
    height: "100%",
    padding: theme.spacing(2),
    boxSizing: "border-box"
  },
  vegaContainer: {
    display: "flex",
    flexDirection: "column",
    //   flexGrow: 1,
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      height: 300,
      margin: theme.spacing(1, 0, 0, 0),
      "&:first-of-type": {
        margin: theme.spacing(0)
      }
    },
    [theme.breakpoints.up("lg")]: {
      width: `calc(50% - ${theme.spacing(1)}px)`,
      height: 300,
      margin: theme.spacing(2, 2, 0, 0),
      "&:nth-child(2n+2)": {
        margin: theme.spacing(2, 0, 0, 0)
      },
      "&:nth-of-type(1)": {
        margin: theme.spacing(0, 2, 0, 0)
      },
      "&:nth-of-type(2)": {
        margin: theme.spacing(0)
      }
    }
  },
  geoFilesButton: {
    "&:first-of-type": {
      [theme.breakpoints.down(1500)]: {
        margin: theme.spacing(0, 0.5, 0, 0),
        padding: "4px 6px"
      },
      [theme.breakpoints.up(1500)]: {
        margin: theme.spacing(0, 1, 0, 0),
        padding: "4px 10px"
      }
    },
    "&:last-of-type": {
      [theme.breakpoints.down(1500)]: {
        padding: "4px 6px"
      },
      [theme.breakpoints.up(1500)]: {
        padding: "4px 10px"
      }
    }
  },
  layerButtonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2)
  },
  layerButtons: {
    marginLeft: theme.spacing(2),
    "&:first-of-type": {
      marginLeft: 0
    }
  },
  anchorOriginBottomCenter: {
    bottom: 56
  },
  header: {
    background: theme.palette.primary.main,
    color: "white",
    fontWeight: 500,
    width: "100%",
    padding: theme.spacing(0.5, 1),
    boxSizing: "border-box",
    boxShadow: theme.shadows[2],
    marginBottom: theme.spacing(1)
  },
  tableRow: {
    "&:nth-child(odd)": {
      backgroundColor: "#eeeeee"
    }
  },
  tableCell: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: theme.spacing(1)
  },
  textArea: {
    minWidth: 300,
    minHeight: 81,
    maxHeight: "100%",
    padding: theme.spacing(1),
    boxSizing: "border-box",
    borderRadius: 4,
    border: "1px solid #dddddd",
    fontFamily: "unset",
    fontSize: "unset",
    outline: "none",
    "&:hover, &:focus": {
      border: "1px solid #aaaaaa"
    }
  }
})

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeStep: 0,
      drawerStates: {},
      editorStateInfo: {},
      mapConfig: {
        key: "main",
        lat: 5.598624,
        lng: -0.217034,
        zoom: 11,
        baseLayers: [
          {
            name: "Map",
            checked: true,
            attribution: "&copy; <a href='http://www.esri.com/' target='_blank'>Esri</a>, | <a href='http://www.hkv.nl/' target='_blank'>HKV Services</a>",
            url: "https://services.arcgisonline.com/arcgis/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}"
          },
          {
            name: "Satalite",
            checked: false,
            attribution: "&copy; <a href='http://www.esri.com/' target='_blank'>Esri</a>, | <a href='http://www.hkv.nl/' target='_blank'>HKV Services</a>",
            url: "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          }
        ],
        layers: [
          {
            type: "wms",
            name: "low_risk",
            key: "low",
            checked: true,
            zoomto: false,
            url: "https://tsgeo.hkvservices.nl/geoserver/wms",
            layer: "layer1",
            workspace: "myfloodrisk_accra",
            styles: [
              "waterdepth"
            ],
            features: []
          },
          {
            type: "wms",
            name: "moderate_risk",
            key: "moderate",
            checked: false,
            zoomto: false,
            url: "https://tsgeo.hkvservices.nl/geoserver/wms",
            layer: "layer2",
            workspace: "myfloodrisk_accra",
            styles: [
              "waterdepth"
            ],
            features: []
          },
          {
            type: "wms",
            name: "high_risk",
            key: "high",
            checked: false,
            zoomto: false,
            url: "https://tsgeo.hkvservices.nl/geoserver/wms",
            layer: "layer3",
            workspace: "myfloodrisk_accra",
            styles: [
              "waterdepth"
            ],
            features: []
          },
          {
            type: "wms",
            name: "App Area",
            key: "Area",
            checked: true,
            zoomto: false,
            url: "https://tsgeo.hkvservices.nl/geoserver/wms",
            layer: "App_area",
            workspace: "myfloodrisk_accra",
            styles: [
              "countries"
            ],
            features: []
          }
        ],
        controls: [
          { name: "LayersControl", position: "topright" },
          { name: "ZoomControl", position: "bottomright" },
          { name: "ScaleControl", position: "bottomleft", metric: true }
        ]
      },
      publishLayers: { low: "", moderate: "", high: "" },
      selectedLayers: [],
      uploadedImages: [],
      viewerType: "dashboard",
      counters: [
        { name: "Number of downloads from the stores", key: "downloads" },
        { name: "Number of automatic push notifications sent (Rainfall forecast)", key: "pushnotifications" },
        { name: "How often each menu item is opened", key: "menuitems", spec: "bar-chart" },
        { name: "How often are locations in MMDAs shown requested", key: "locationrequests", spec: "bar-chart" },
        { name: "How often is the returned risk (low/moderate/high)", key: "floodrisk", spec: "bar-chart" },
        { name: "Combination of risk per MMDA", key: "combination", spec: "bar-chart-combination" }
      ]
    }

    this.mapRefs = {}
    this.vegaRefs = {}
    this.featureGroupRefs = {}

    const that = this
    const { dispatch } = this.props

    const showdown = require("showdown")
    const converter = new showdown.Converter()

    this.onDragEnd = this.onDragEnd.bind(this)

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 2 + that.state.counters.length))
      .then(() => {
        // Checken of gebruiker is ingelogd
        onAuthStateChanged(dispatch, function (userinfo) {
          // Als gebruiker verified is haal locaties op
          if (userinfo.verified) {
            that.props.dispatch(asyncActions.getAppInfo("tsws", "myfloodrisk", { appid: 42, admin: true }))
              .then((appinfo) => {
                if (JSON.stringify(window.localStorage.selectedLanguage)) {
                  that.changeLanguage(that, window.localStorage.selectedLanguage)
                } else {
                  if (appinfo && appinfo.languages) {
                    that.changeLanguage(that, appinfo.languages.find(language => language.preference === true).short)
                  } else {
                    that.changeLanguage(that, "en")
                  }
                }

                that.props.dispatch(asyncActions.getRainfallForecast("tsws"))
                  .then(() => {
                    that.props.dispatch(asyncActions.setLoader(that.props.database.loading - 1))
                  })

                that.state.counters.forEach(counter => {
                  that.getFirestoreData(counter, function () {
                    that.props.dispatch(asyncActions.setLoader(that.props.database.loading - 1))
                  })
                })

                that.props.dispatch(asyncActions.getContent("tsws", { appid: 42, key: "DISCLAIMER", uid: userinfo.uid, token: userinfo.token }, "contentType=text/plain"))
                  .then(text => {
                    const html = converter.makeHtml(text)
                    // const blocksFromHTML = convertFromHTML(html)
                    const blocksFromHTML = htmlToDraft(html)

                    const state = ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)

                    that.setState({ editorStateDisclaimer: EditorState.createWithContent(state) })
                  })

                appinfo.riskSituationLayers.forEach(layer => {
                  const floodRiskLayer = that.state.mapConfig.layers.find(overlay => overlay.key === layer.key)

                  if (floodRiskLayer) {
                    that.state.publishLayers[layer.key] = layer.layer
                    that.setState({ publishLayers: that.state.publishLayers })

                    floodRiskLayer.description = layer.description
                    floodRiskLayer.layer = layer.layer
                    floodRiskLayer.workspace = layer.workspace
                    floodRiskLayer.styles = [layer.styles]
                  }
                })

                that.props.dispatch(asyncActions.getScheduledNotifications("tsws", { appid: 42 }))
                  .then(() => {
                    that.setState({ mapConfig: that.state.mapConfig }, () => {
                      // Slides ophalen (voor Literacy information)
                      that.getInfoSlides()
                    })
                  })
              })
          } else {
            // Als user niet verified is (bijvoorbeeld wanneer je op een app anoniem bent ingelogd), loguit
            doSignOut(dispatch, function (userinfo) {
              that.props.dispatch(asyncActions.setLoader(that.props.database.loading - (2 + that.state.counters.length)))
            })
          }
        })
      })
  }

  changeLanguage = (that, lng) => {
    i18n.changeLanguage(lng)

    // Moment (tijdzones etc) lang zetten
    moment.locale(lng)

    that.state.selectedLanguage = lng
    window.localStorage.selectedLanguage = lng
  }

  mapDidMount = (mapRef) => {
    this.mapRefs[mapRef.key] = mapRef
  }

  getFirestoreData = (counter, callback) => {
    const { counters } = this.state

    let documents = []
    const data = []

    const that = this

    switch (counter.key) {
      case "downloads":
        documents = [
          { name: "App store (iOS)", key: "storeDownloads", field: "iOS" },
          { name: "Play store (Android)", key: "storeDownloads", field: "Android" }
        ]; break

      case "pushnotifications":
        documents = [
          { name: "Send push notifications", key: "pushNotifications", field: "count" }
        ]; break

      case "menuitems":
        documents = [
          { name: "House", key: "menuItems", field: "house" },
          { name: "Map", key: "menuItems", field: "map" },
          { name: "Information", key: "menuItems", field: "information" },
          { name: "Disclaimer", key: "menuItems", field: "disclaimer" },
          { name: "Demo", key: "menuItems", field: "demo" },
          { name: "Rainfall", key: "menuItems", field: "rainfall" }
        ]; break

      case "locationrequests":
        documents = [
          { name: "Accra Metropolitan", key: "Accra_Metropolitan_MMDA", field: "count" },
          { name: "GA East Municipal", key: "Ga_East_Municipal_MMDA", field: "count" },
          { name: "GA West Municipal", key: "Ga_West_Municipal_MMDA", field: "count" }
        ]; break

      case "floodrisk":
        documents = [
          { name: "Low", key: "returnedRiskLow", field: "count" },
          { name: "Moderate", key: "returnedRiskModerate", field: "count" },
          { name: "High", key: "returnedRiskHigh", field: "count" }
        ]; break

      case "combination":
        documents = [
          { name: "Total", locationKey: "Accra - Total", key: "Accra_Metropolitan_MMDA", field: "count", location: "Accra Metropolitan" },
          { name: "Low", locationKey: "Accra - Low", key: "Accra_Metropolitan_MMDA", field: "low", location: "Accra Metropolitan" },
          { name: "Moderate", locationKey: "Accra - Moderate", key: "Accra_Metropolitan_MMDA", field: "moderate", location: "Accra Metropolitan" },
          { name: "High", locationKey: "Accra - High", key: "Accra_Metropolitan_MMDA", field: "high", location: "Accra Metropolitan" },
          { name: "Total", locationKey: "GA East - Total", key: "Ga_East_Municipal_MMDA", field: "count", location: "Ga East Municipal" },
          { name: "Low", locationKey: "GA East - Low", key: "Ga_East_Municipal_MMDA", field: "low", location: "Ga East Municipal" },
          { name: "Moderate", locationKey: "GA East - Moderate", key: "Ga_East_Municipal_MMDA", field: "moderate", location: "Ga East Municipal" },
          { name: "High", locationKey: "GA East - High", key: "Ga_East_Municipal_MMDA", field: "high", location: "Ga East Municipal" },
          { name: "Total", locationKey: "GA West - Total", key: "Ga_West_Municipal_MMDA", field: "count", location: "Ga West Municipal" },
          { name: "Low", locationKey: "GA West - Low", key: "Ga_West_Municipal_MMDA", field: "low", location: "Ga West Municipal" },
          { name: "Moderate", locationKey: "GA West - Moderate", key: "Ga_West_Municipal_MMDA", field: "moderate", location: "Ga West Municipal" },
          { name: "High", locationKey: "GA West - High", key: "Ga_West_Municipal_MMDA", field: "high", location: "Ga West Municipal" }
        ]; break

      default:
        break
    }

    let type = "counter"
    if (counter.spec) {
      type = "vega"
    }

    // Document zijn ref ophalen
    if (documents.length > 0) {
      documents.forEach(document => {
        const ref = firestore.collection("counters").doc(document.key)

        if (ref) {
          ref.onSnapshot(snapshot => {
            if (snapshot.exists) {
              // Als document bestaat zet field waardes in data array
              // Bij combinatio nis de name niet unique dus moeten we de locationKey gebruiken
              if (counter.key === "combination") {
                if (data.find(d => d.locationKey === document.locationKey)) {
                  data.find(d => d.locationKey === document.locationKey).value = snapshot.data()[document.field]
                } else {
                  data.push({ name: document.name, value: snapshot.data()[document.field], location: document.location })
                }
              } else {
                if (data.find(d => d.name === document.name)) {
                  data.find(d => d.name === document.name).value = snapshot.data()[document.field]
                } else {
                  data.push({ name: document.name, value: snapshot.data()[document.field] })
                }
              }

              // Als we evenveel data hebben als dat we documenten hebben pushen we de data naar vega
              // Behalve wanneer we al een keer geinitialiseerd hebben, dan veranderen alleen bepaalde objecten real time
              if (data.length === documents.length || counter.isInitialized) {
                counters.find(c => c.key === counter.key).data = data
                that.setState({ counters }, () => {
                  if (type === "vega") {
                    const viewObject = that.vegaRefs[counter.key]

                    that.props.dispatch(asyncActions.updateVegaData(viewObject, "table", data))
                  }
                })

                // Als we een update doen hoeven we niet de callback uit te voeren
                if (callback && !counter.isInitialized) {
                  counter.isInitialized = true
                  callback(data)
                }
              }
            }
          })
        } else {
          if (callback) {
            callback()
          }
        }
      })
    }
  }

  vegaDidMount = (viewObject) => {
    const { counters } = this.state

    this.vegaRefs[viewObject.key] = viewObject

    const data = counters.find(vega => vega.key === viewObject.key).data

    let title = ""
    switch (viewObject.key) {
      case "downloads": title = "Amount of downloads"; break
      case "pushnotifications": title = "Send push notifications"; break
      case "menuitems": title = "Menu clicks"; break
      case "locationrequests": title = "Region's"; break
      case "floodrisk": title = "Risks returned"; break
      case "combination": title = "Risks returned per region"; break
      default: break
    }

    if (data && data.length > 0) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          this.props.dispatch(asyncActions.sendSignal(viewObject, { signalName: "xscaleTitle", value: title }))
          this.props.dispatch(asyncActions.sendSignal(viewObject, { signalName: "xscaleAlign", value: data.length > 6 ? "right" : "center" }))
          this.props.dispatch(asyncActions.sendSignal(viewObject, { signalName: "labelAngle", value: data.length > 6 ? -25 : 0 }))
            .then(() => {
              this.props.dispatch(asyncActions.updateVegaData(viewObject, "table", data))
                .then(() => {
                  this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
                })
            })
        })
    }
  }

  featureGroupDidAdd = (groupRef) => {
    this.featureGroupRefs[groupRef.key] = groupRef
  }

  getInfoSlides = (zoomToEnd) => {
    const { database } = this.props
    const { editorStateInfo } = this.state

    const showdown = require("showdown")
    const converter = new showdown.Converter()

    this.props.dispatch(asyncActions.getSlides("tsws", { appid: 42 }))
      .then((json) => {
        const slides = json.filter(obj => obj.key !== "DISCLAIMER")

        // Steps zijn de keys 
        const infoSlides = []
        slides.forEach((slide, index) => {
          const currentNotification = database.notifications && database.notifications.find(notification => notification.key === slide.key)

          let currentNotificationStartTime = null
          let currentNotificationEndTime = null
          if (currentNotification) {
            currentNotificationStartTime = currentNotification.starttime
            currentNotificationEndTime = currentNotification.endtime
          }

          infoSlides.push({
            id: `item-${slide.orderid}`,
            category: slide.category,
            orderid: slide.orderid,
            key: slide.key,
            starttime: moment(currentNotificationStartTime).format("YYYY-MM-DD"),
            endtime: moment(currentNotificationEndTime).format("YYYY-MM-DD"),
            active: currentNotification ? currentNotification.active : false,
            notificationId: currentNotification && currentNotification.id,
            occurrence: currentNotification && currentNotification.occurrence
          })

          const html = converter.makeHtml(slide.text)

          const contentBlock = htmlToDraft(html)
          // const blocksFromHTML = convertFromHTML(html)
          // const state = ContentState.createFromBlockArray(
          //   blocksFromHTML.contentBlocks,
          //   blocksFromHTML.entityMap
          // )

          if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
            const editorState = EditorState.createWithContent(contentState)

            editorStateInfo[slide.key] = editorState
          }

          // editorStateInfo[slide.key] = EditorState.createWithContent(state)

          if (index + 1 === slides.length) {
            this.setState({ editorStateInfo, infoSlides }, () => {
              if (zoomToEnd) {
                this.setState({ activeStep: slides.length - 1 }, () => {
                  this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
                })
              } else {
                this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
              }
            })
          }
        })
      })
  }

  renderAnalytics = () => {
    const { classes, theme } = this.props
    const { counters } = this.state

    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {counters.map((counter, index) => {
          if (counter.spec) {
            return (
              <Paper key={index} square className={classes.vegaContainer}>
                <Typography className={classes.header}>
                  {counter.name}
                </Typography>
                <div style={{ display: "flex", height: `calc(100% - (32px + ${theme.spacing(2)}px))`, margin: theme.spacing(0, 1, 1) }}>
                  {counter.data && <HKVVega
                    config={{ type: "vega", specName: counter.spec, key: counter.key }}
                    vegaDidMount={this.vegaDidMount}
                  />}
                </div>
              </Paper>
            )
          } else {
            if (counter.key === "downloads") {
              return (
                <Paper key={index} square className={classes.vegaContainer} style={{ height: 150 }}>
                  <Typography className={classes.header}>
                    {counter.name}
                  </Typography>
                  <div style={{ display: "flex", height: `calc(100% - (32px + ${theme.spacing(2)}px))`, margin: theme.spacing(0, 1, 1) }}>
                    {counter.data && counter.data.map((data, index) => (
                      <div key={index} style={{ flexGrow: 1, textAlign: "center" }}>
                        <Typography color="primary" style={{ fontSize: theme.typography.pxToRem(60) }}>{data.value}</Typography>
                        <Typography style={{ marginTop: -theme.spacing(1) }}>{data.name}</Typography>
                      </div>
                    ))}
                  </div>
                </Paper>
              )
            } else {
              return (
                <Paper key={index} square className={classes.vegaContainer} style={{ height: 150 }}>
                  <Typography className={classes.header}>
                    {counter.name}
                  </Typography>
                  <div style={{ display: "flex", height: `calc(100% - (32px + ${theme.spacing(2)}px))`, margin: theme.spacing(0, 1, 1) }}>
                    {counter.data && <Typography color="primary" style={{ margin: "auto", fontSize: theme.typography.pxToRem(60) }}>{counter.data[0].value}</Typography>}
                  </div>
                </Paper>
              )
            }
          }
        })}
      </div>
    )
  }

  onLayerChange = (layers, layer, type) => {
    const { mapConfig } = this.state

    switch (type) {
      case "radio":
        // Alle layers op checked false zetten behalve geselecteerde layer
        layers.forEach(l => { l.checked = false })
        layer.checked = true

        this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
          .then(() => {
            this.setState({ mapConfig }, () => {
              this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            })
          })
        break

      case "checkbox":
      default:
        // Zoek in config naar layer en zet deze op checked true/ false
        layers.find(l => l.key === layer.key).checked = !layer.checked

        this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
          .then(() => {
            this.setState({ mapConfig }, () => {
              this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            })
          })
        break
    }
  }

  onResizeTextArea = () => {
    const element = document.getElementById("forecastTable")

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.setState({ rainfallTableHeight: element.offsetHeight }, () => {
          this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
        })
      })
  }

  changePushNotificationTitle = (event) => {
    const title = event.target.value

    if (title.length > 40) return null

    this.setState({ pushNotificationTitle: title })
  }

  changePushNotificationText = (event) => {
    const text = event.target.value

    if (text.length > 80) return null

    this.setState({ pushNotificationText: text })
  }

  sendPushNotification = () => {
    const { pushNotificationText, pushNotificationTitle } = this.state

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.sendPushNotification("tsws", "myfloodrisk", { appid: 42, topic: "literacyInformation", title: pushNotificationTitle, message: pushNotificationText }))
          .then((json) => {
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            this.props.dispatch({ type: actions.SET_ERROR, error: { message: "Push Notification has been sent", type: "success", duration: 3000, key: moment().valueOf() } })
          })
      })
  }

  renderForecast = () => {
    const { classes, database, theme } = this.props
    const { pushNotificationText, pushNotificationTitle, rainfallTableHeight } = this.state

    const forecastData = database.forecast.locations.filter(location => location.name === "Accra")

    const columns = [
      { name: "Name", value: "name" },
      { name: database.forecast.period1, value: "valuePeriod1" },
      { name: database.forecast.period2, value: "valuePeriod2" },
      { name: database.forecast.period3, value: "valuePeriod3" }
    ]

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Paper id="forecastTable" square style={{ margin: theme.spacing(0, 0, 1) }}>
          <Typography className={classes.header}>Rainfall Forecast Accra</Typography>
          <table style={{ width: `calc(100% - ${theme.spacing(2)}px)`, borderCollapse: "collapse", margin: theme.spacing(1) }}>
            <thead>
              <tr>
                {columns.map((column, index) => (
                  <th key={index} className={classes.tableCell}>{column.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {forecastData.map((data, index) => (
                <tr key={index} className={classes.tableRow}>
                  {columns.map((column, i) => (
                    <td key={i} className={classes.tableCell}>{forecastData[index][column.value]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </Paper>
        <Paper square style={{ display: "flex", flexDirection: "column", maxHeight: rainfallTableHeight ? `calc(100% - (${rainfallTableHeight}px + ${theme.spacing(1)}px))` : "unset" }}>
          <Typography className={classes.header}>Send push notification</Typography>
          <div style={{ display: "flex", flexDirection: "column", margin: theme.spacing(0, 1, 1) }}>
            <TextField
              placeholder="Title of the push notification"
              className={classes.textField}
              onChange={this.changePushNotificationTitle}
              value={pushNotificationTitle}
            />
          </div>
          <Typography variant="caption" style={{ margin: theme.spacing(0, 1) }}>{pushNotificationTitle ? pushNotificationTitle.length : 0} out of 40 characters</Typography>
          {/* 32px voor titel 32px voor push title, 2x 19px voor chars tekst, 2x theme spacing voor margin */}
          <div style={{ display: "flex", maxHeight: `calc(100% - (32px + 32px + 19px + 19px + ${theme.spacing(2)}px))`, margin: theme.spacing(0, 1, 0) }}>
            <TextareaAutosize
              placeholder="Type a message which you want to send to ALL app users"
              className={classes.textArea}
              onMouseDown={this.onResizeTextArea}
              onChange={this.changePushNotificationText}
              value={pushNotificationText}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={!pushNotificationTitle || !pushNotificationText}
              style={{ height: "fit-content", alignSelf: "flex-end", marginLeft: theme.spacing(1) }}
              onClick={() => this.sendPushNotification()}
            >
              Send
            </Button>
          </div>
          <Typography variant="caption" style={{ margin: theme.spacing(0, 1) }}>{pushNotificationText ? pushNotificationText.length : 0} out of 80 characters</Typography>
        </Paper>
      </div>
    )
  }

  beforeRemoveSlide = (key) => {
    this.setState({ removeDialog: { open: true, size: "small", key: key } })
  }

  removeSlide = (config) => {
    const { activeStep, infoSlides } = this.state

    this.closeDialog(config)

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.deleteContent("tsws", { appid: 42, key: config.key }))
          .then(() => {
            // Als gebruiker de laatste slide delete, ga 1 stap terug
            if (activeStep + 1 === infoSlides.length) {
              this.setState({ activeStep: activeStep === 0 ? 0 : activeStep - 1 })
            }

            infoSlides.forEach((infoSlide, index) => {
              // De verwijderde slide ook uit de state verwijderen
              if (index === activeStep) {
                infoSlides.splice(index, 1)

                this.setState({ infoSlides }, () => {
                  this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
                })
              }
            })

            this.props.dispatch({ type: actions.SET_ERROR, error: { message: "Literacy information slide has been removed", type: "info", duration: 3000, key: moment().valueOf() } })
          })
      })
  }

  addSlide = () => {
    const { firebase } = this.props
    const { editorStateInfo, infoSlides } = this.state

    const showdown = require("showdown")
    const converter = new showdown.Converter()

    const that = this

    const uploadUrl = getUploadUrl("tsws")

    let key = ""
    let fileName = ""

    const time = moment().valueOf()

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        key = `INFO${time}`
        fileName = `info${time}.json`

        const markdownString = "## Hello world!"

        // De laatste infoSlide zijn orderid + 1
        const parameters = { appid: 42, key: key, category: "literacyEarlyWarningModule", orderid: infoSlides[infoSlides.length - 1].orderid + 1 }

        const headers = [
          { key: "function", value: "myfloodrisk.appfunctions.SetContent" },
          { key: "parameters", value: JSON.stringify(parameters) },
          { key: "uid", value: firebase.userinfo.uid },
          { key: "token", value: firebase.userinfo.token }
        ]

        const file = { value: { name: fileName }, content: markdownString }

        makeRequest("POST", uploadUrl, headers, file, function (newFile) {
          const newFileParsed = JSON.parse(newFile.responseText)

          const html = converter.makeHtml(newFileParsed.text)

          const blocksFromHTML = convertFromHTML(html)
          const state = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
          )

          editorStateInfo[newFileParsed.key] = EditorState.createWithContent(state)

          // In infoSlides willen we nu een nieuw object pushen
          infoSlides.push({ id: `item-${newFileParsed.orderid}`, category: newFileParsed.category, orderid: newFileParsed.orderid, key: newFileParsed.key })

          // Daarna gaan we naar de laatst toegevoegde slide
          that.setState({ editorStateInfo, infoSlides }, () => {
            that.goToStep(infoSlides.length)
            that.props.dispatch(asyncActions.setLoader(that.props.database.loading - 1))
          })

          that.props.dispatch({ type: actions.SET_ERROR, error: { message: "Literacy information slide has been added", type: "success", duration: 3000, key: moment().valueOf() } })
        })
      })
  }

  uploadImageCallback = (file) => {
    return new Promise((resolve, reject) => {
      this.props.dispatch(asyncActions.UploadImageToServer(file, file.name))
        .then((result) => {
          const url = result.url
          resolve({ data: { link: url } })
        })
    })
  }

  reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  getItemStyle = (isDragging, draggableStyle, index) => {
    const { theme } = this.props
    const { activeStep } = this.state

    return ({
      userSelect: "none",
      padding: theme.spacing(0.5, 1),
      margin: index === 0 ? 0 : `${theme.spacing(1)}px 0 0 0`,
      border: isDragging ? "1px dashed black" : "unset",
      fontWeight: activeStep === index ? 600 : 400,

      // Styles we need to apply on draggables
      ...draggableStyle
    })
  }

  onDragEnd = (result) => {
    // Wanneer buiten dropzone gedropt
    if (!result.destination) {
      return
    }

    const infoSlides = this.reorder(
      this.state.infoSlides,
      result.source.index,
      result.destination.index
    )

    infoSlides.forEach((slide, index) => {
      slide.orderid = (index + 1)

      this.setState({ infoSlides })

      // Nieuwe slide order naar de database sturen
      this.props.dispatch(asyncActions.setOrderId("tsws", "myfloodrisk", { appid: 42, key: slide.key, orderid: slide.orderid }))
    })
  }

  changeSlideCategory = (event, slide) => {
    const { infoSlides } = this.state

    infoSlides.find(infoSlide => infoSlide.key === slide.key).category = event.target.value

    // Nieuwe slide category naar de database sturen
    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.setCategory("tsws", "myfloodrisk", { appid: 42, key: slide.key, category: event.target.value }))
        this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
      })
  }

  renderSlideCategory = () => {
    const { classes, theme } = this.props
    const { activeStep, infoSlides } = this.state

    const options = [
      "literacyEarlyWarningModule",
      "literacyICRM",
      "literacyInformation"
    ]

    return (
      <Paper square style={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" className={classes.header}>
          Current slide category
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", padding: theme.spacing(1) }}>
          <InputLabel>Category</InputLabel>
          <Select
            value={infoSlides[activeStep] && infoSlides[activeStep].category}
            disabled={infoSlides.length === 0}
            onChange={(event) => this.changeSlideCategory(event, infoSlides[activeStep])}
          >
            {options.map((option, index) => (
              <MenuItem key={index} value={option}>{option}</MenuItem>
            ))}
          </Select>
        </div>
      </Paper>
    )
  }

  renderSlideOrder = () => {
    const { classes, theme } = this.props
    const { infoSlides } = this.state

    const styleSheet = document.styleSheets[0]

    const keyframes = `@-webkit-keyframes up-down {
        0% {top: 10%}
        50% {top: calc(90% - 26px)}
        100% {top: 10%}
    }`

    styleSheet.insertRule(keyframes, styleSheet.cssRules.length)

    return (
      <Paper square style={{ display: "flex", flexDirection: "column", marginBottom: theme.spacing(1) }}>
        <Typography variant="h6" className={classes.header}>
          IDRM Literacy Information
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", margin: theme.spacing(0, 1, 1) }}>
          <Typography gutterBottom variant="body2">Drag the items below to change its order, and click them to navigate.</Typography>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  style={{
                    border: snapshot.isDraggingOver ? "1px dashed gray" : "1px dashed lightgray",
                    padding: theme.spacing(1),
                    width: "100%",
                    boxSizing: "border-box"
                  }}
                >
                  {infoSlides.map((slide, index) => (
                    <Draggable key={slide.id} draggableId={slide.id} index={index}>
                      {(provided, snapshot) => (
                        <Paper
                          square
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={this.getItemStyle(snapshot.isDragging, provided.draggableProps.style, index)}
                          onClick={() => this.goToStep(index)}
                        >
                          {slide.key}
                        </Paper>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </Paper>
    )
  }

  changePushCheckedState = (event, slide) => {
    const { infoSlides } = this.state

    slide.active = event.target.checked

    this.setState({ infoSlides: infoSlides })
  }

  changePushDate = (event, slide, type) => {
    const { infoSlides } = this.state

    slide[`${type}time`] = moment(event.target.value).valueOf()

    this.setState({ infoSlides: infoSlides })
  }

  addScheduledNotification = (slide) => {
    const { infoSlides } = this.state

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.addScheduledNotification("tsws", {
          appid: 42,
          key: slide.key,
          title: "New Literacy Information slide",
          message: "There is a new Literacy Information available",
          starttime: moment(slide.starttime).valueOf(),
          endtime: slide.occurrence === "once" ? 0 : moment(slide.endtime).valueOf(),
          active: slide.active,
          id: slide.notificationId,
          occurrence: slide.occurrence
        }))
          .then((notifications) => {
            slide.notificationId = notifications[notifications.length - 1].id

            this.setState({ infoSlides: infoSlides })
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
      })
  }

  changeOccurrence = (event, slide) => {
    const { infoSlides } = this.state

    slide.occurrence = event.target.value

    this.setState({ infoSlides: infoSlides })
  }

  renderLiteracy = () => {
    const { classes, t, theme } = this.props
    const { activeStep, editorStateInfo, infoSlides } = this.state

    const toolbar = {
      options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker", "image", "link"],
      image: {
        urlEnabled: false,
        uploadCallback: this.uploadImageCallback,
        previewImage: true,
        alt: { present: true, mandatory: false },
        inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg,video/mp4"
      },
      link: {
        linkCallback: this.linkCallback
      }
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Paper square style={{ display: "flex", flexDirection: "column", flexGrow: 1, margin: theme.spacing(0, 0, 1), height: "calc(100% - (46px + 8px))" }}>
          <SwipeableViews index={activeStep} onChangeIndex={(index, indexLatest) => this.handleStep(index > indexLatest ? "next" : "back")} style={{ flexGrow: 1 }}>
            {infoSlides.map((slide, index) => {
              let disabled = true
              if (slide.occurrence === "once") {
                disabled = !slide.starttime || slide.starttime === "Invalid date"
              } else {
                disabled = !slide.starttime || slide.starttime === "Invalid date" || !slide.endtime || slide.endtime === "Invalid date" || !slide.occurrence
              }
              return (
                <div key={index} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                  <div className={classes.header} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Typography variant="h6">Literacy information slide</Typography>
                    <div style={{ display: "flex" }}>
                      <Tooltip title="Remove current slide">
                        <span>
                          <IconButton size="small" color="secondary" disabled={infoSlides.length === 1} onClick={() => this.beforeRemoveSlide(slide.key)}>
                            <Delete />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <Tooltip title="Add slide">
                        <IconButton size="small" color="secondary" style={{ marginLeft: theme.spacing(1) }} onClick={() => this.addSlide()}>
                          <Add />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                  <Editor
                    editorState={editorStateInfo[slide.key]}
                    wrapperClassName="wrapper"
                    editorClassName="editor"
                    onEditorStateChange={(editorState) => this.onInfoEditorStateChange(editorState, slide.key)}
                    toolbar={toolbar}
                    // https://github.com/jpuri/react-draft-wysiwyg/issues/697
                    handlePastedText={() => false}
                  />
                  <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", margin: theme.spacing(1), padding: theme.spacing(1), border: "1px solid #F1F1F1" }}>
                    <Typography variant="body2" style={{ width: "100%", marginBottom: theme.spacing(0.5) }}>To set a scheduled notification for this slide, select a date and mark active. When active a push notification will be send to the app users on the selected day.</Typography>
                    <TextField
                      type="date"
                      defaultValue={slide.starttime}
                      className={classes.textField}
                      onChange={(event) => this.changePushDate(event, slide, "start")}
                      InputLabelProps={{
                        shrink: true
                      }}
                      label={t("Start_date")}
                      style={{ marginRight: theme.spacing(2) }}
                    />
                    <TextField
                      type="date"
                      defaultValue={slide.endtime}
                      disabled={slide.occurrence === "once" ? true : false}
                      className={classes.textField}
                      onChange={(event) => this.changePushDate(event, slide, "end")}
                      InputLabelProps={{
                        shrink: true
                      }}
                      label={t("End_date")}
                      style={{ marginRight: theme.spacing(2) }}
                    />
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginRight: theme.spacing(2) }}>
                      <Typography color="textSecondary" variant="caption" style={{ cursor: "default", lineHeight: 1 }}>{t("Active")}</Typography>
                      <Checkbox
                        checked={slide.active}
                        onChange={(event) => this.changePushCheckedState(event, slide)}
                        color="primary"
                        style={{ margin: "11px 0 0", padding: 0 }}
                      />
                    </div>
                    <FormControl
                      style={{ minWidth: 120, marginRight: theme.spacing(2) }}
                    >
                      <InputLabel>{t("Occurrence")}</InputLabel>
                      <Select
                        value={slide.occurrence ? slide.occurrence : ""}
                        onChange={(e) => this.changeOccurrence(e, slide)}
                      >
                        <MenuItem value="once">{t("Once")}</MenuItem>
                        <MenuItem value="daily">{t("Daily")}</MenuItem>
                        <MenuItem value="weekly">{t("Weekly")}</MenuItem>
                        <MenuItem value="monthly">{t("Monthly")}</MenuItem>
                        <MenuItem value="yearly">{t("Yearly")}</MenuItem>
                      </Select>
                    </FormControl>
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={disabled}
                      onClick={() => this.addScheduledNotification(slide)}
                    >
                      {t("Set_scheduled_notification")}
                    </Button>
                  </div>
                </div>
              )
            })}
          </SwipeableViews>
        </Paper>
        <div className='dialog-actions' style={{ marginTop: theme.spacing(1) }}>
          <MobileStepper
            steps={infoSlides.length}
            position='static'
            activeStep={activeStep}
            className='mobilestepper'
            backButton={<Button onClick={() => this.handleStep("back")} disabled={activeStep === 0}><ChevronLeft />{t("Previous")}</Button>}
            nextButton={<Button onClick={() => this.handleStep("next")} disabled={activeStep === infoSlides.length - 1}>{t("Next")}<ChevronRight /></Button>}
          />
          <Button
            variant="contained"
            color="primary"
            className="dialog-button"
            onClick={() => this.publishInfo()}
          >
            Publish
          </Button>
        </div>
      </div>
    )
  }

  renderFloodRiskMaps = () => {
    const { classes } = this.props
    const { mapConfig } = this.state

    const layers = [
      { name: "Low risk", value: "low" },
      { name: "Moderate risk", value: "moderate" },
      { name: "High risk", value: "high" }
    ]

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Paper square style={{ height: "100%" }}>
          <HKVMap config={mapConfig} mapDidMount={this.mapDidMount} featureGroupDidAdd={this.featureGroupDidAdd} />
        </Paper>
        <div className={classes.layerButtonContainer}>
          {layers.map((layer, index) => (
            <Button
              key={index}
              variant="contained"
              color="primary"
              className={classes.layerButtons}
              style={{
                backgroundColor: mapConfig.layers.find(l => l.key === layer.value).checked && "#005686"
              }}
              onClick={() => this.onLayerChange(mapConfig.layers.filter(l => l.key !== "Area"), mapConfig.layers.find(l => l.key === layer.value), "radio")}
            >
              {layer.name}
            </Button>
          ))}
        </div>
      </div>
    )
  }

  onDisclaimerStateChange = (editorState) => {
    let { editorStateDisclaimer } = this.state

    // Om er voor te zorgen dat je de melding 'Changes you made may not be saved' te tonen wanneer je de pagina sluit zonder op te slaan
    window.onbeforeunload = () => ""

    editorStateDisclaimer = editorState

    this.setState({ editorStateDisclaimer })
  }

  onInfoEditorStateChange = (editorState, key) => {
    const { editorStateInfo } = this.state

    // Om er voor te zorgen dat je de melding 'Changes you made may not be saved' te tonen wanneer je de pagina sluit zonder op te slaan
    window.onbeforeunload = () => ""

    editorStateInfo[key] = editorState
    this.setState({ editorStateInfo })
  }

  linkCallback = (e) => {
    return { title: e.title, target: e.target, targetOption: e.targetOption }
  }

  renderDisclaimerEditor = () => {
    const { theme } = this.props
    const { editorStateDisclaimer } = this.state

    const toolbar = {
      options: ["inline", "blockType", "fontSize", "list", "textAlign", "colorPicker", "image", "link"],
      image: {
        urlEnabled: false,
        uploadCallback: this.uploadImageCallback,
        previewImage: true,
        alt: { present: true, mandatory: false },
        inputAccept: "image/gif,image/jpeg,image/jpg,image/png,image/svg,video/mp4"
      },
      link: {
        linkCallback: this.linkCallback
      }
    }

    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Editor
          editorState={editorStateDisclaimer}
          wrapperClassName="wrapper"
          editorClassName="editor"
          onEditorStateChange={this.onDisclaimerStateChange}
          toolbar={toolbar}
          // https://github.com/jpuri/react-draft-wysiwyg/issues/697
          handlePastedText={() => false}
        />
        <Button
          variant="contained"
          color="primary"
          style={{ width: "fit-content", alignSelf: "flex-end", marginTop: theme.spacing(1) }}
          onClick={() => this.publishDisclaimer()}
        >
          Publish
        </Button>
      </div>
    )
  }

  renderContent = (viewerType) => {
    switch (viewerType) {
      case "dashboard": return this.renderAnalytics()
      case "forecast": return this.renderForecast()
      case "literacy": return this.renderLiteracy()
      case "floodriskmaps": return this.renderFloodRiskMaps()
      case "disclaimer": return this.renderDisclaimerEditor()
      default: return null
    }
  }

  drawerStateChanged = (placement, state) => {
    const { drawerStates } = this.state

    drawerStates[placement] = state
    this.setState({ drawerStates })
  }

  onUploaded = (file) => {
    const { application } = this.props
    // const riskSituationLayers = JSON.parse(file.responseText)
    const riskSituationLayers = file.responseText

    application.appinfo.riskSituationLayers = riskSituationLayers
    this.props.dispatch({ type: actions.SET_APP_INFO, appinfo: application.appinfo })

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
  }

  uploadFile = (file) => {
    const { firebase } = this.props
    const that = this

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        const uploadUrl = getUploadUrl("tsws")
        const formData = new FormData()
        const parameters = {
          appid: 42,
          debug: true,
          style: "myfloodrisk_accra:waterdepth",
          plain: true
        }

        formData.append("File", file)
        formData.append("function", "myfloodrisk.appfunctions.AddLayer")
        formData.append("parameters", JSON.stringify(parameters))
        formData.append("uid", firebase.userinfo.uid)
        formData.append("token", firebase.userinfo.token)

        fetch(
          uploadUrl,
          {
            method: "POST",
            body: formData
          })
          .then((response) => response.json())
          .then((result) => {
            file.responseText = result
            that.onUploaded(file)
          })
          .catch((error) => {
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
            this.props.dispatch({ type: actions.SET_ERROR, error: { message: error, type: "error", duration: 4000, key: moment().valueOf() } })
          })
      })
  }

  handleButtonClick = (funct) => {
    const { selectedLayers, publishLayers } = this.state

    switch (funct) {
      case "addFile": document.getElementsByClassName("dx-fileuploader-button")[0].click(); break
      case "publishLayers": this.publishLayers(publishLayers.low, publishLayers.moderate, publishLayers.high); break
      case "deleteFile": this.deleteLayers(selectedLayers); break
      default: break
    }
  }

  deleteLayers = (selectedLayers) => {
    const { application } = this.props

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.deleteLayers("tsws", { appid: 42, layers: JSON.stringify(selectedLayers) }))
          .then(riskSituationLayers => {
            this.clearSelectedLayer()
            application.appinfo.riskSituationLayers = riskSituationLayers
            this.props.dispatch({ type: actions.SET_APP_INFO, appinfo: application.appinfo })

            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
      })
  }

  renderGeoFiles = () => {
    const { application, classes, theme } = this.props
    const { selectedLayers } = this.state

    return (
      <Paper square style={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h6" className={classes.header}>
          GeoFiles
        </Typography>
        <RadioGroup style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "nowrap",
          padding: theme.spacing(1),
          maxHeight: 200,
          overflow: "auto"
        }}
        >
          {application.appinfo.riskSituationLayers.map((layer, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  color="primary"
                  style={{ padding: 0, marginRight: theme.spacing(0.5) }}
                  onClick={(event) => this.setSelectedLayer(event)}
                />
              }
              label={layer.name}
              value={layer.name}
              style={{ margin: index === 0 ? 0 : theme.spacing(1, 0, 0, 0) }}
              disabled={layer.name === "T2" || layer.name === "T10" || layer.name === "T100" || layer.key === "low" || layer.key === "moderate" || layer.key === "high"}
              checked={!(layer.name === "T2" || layer.name === "T10" || layer.name === "T100" || layer.key === "low" || layer.key === "moderate" || layer.key === "high") &&
                selectedLayers.includes(layer.name)}
            />
          ))}
        </RadioGroup>
        <div style={{ textAlign: "right", padding: theme.spacing(1) }}>
          <FileUploader
            id="fileUploader"
            accept=".tif"
            allowedFileExtensions={[".tif"]}
            multiple
            uploadMode="instantly"
            uploadFile={this.uploadFile}
            style={{ display: "none" }}
          />
          <Button
            color="primary"
            variant="contained"
            className={classes.geoFilesButton}
            size="small"
            onClick={() => this.handleButtonClick("addFile")}
          >
            Add .tif file
          </Button>
          <Button
            color="primary"
            variant="contained"
            className={classes.geoFilesButton}
            size="small"
            onClick={() => this.handleButtonClick("deleteFile")}
          >
            Delete selected
          </Button>
        </div>
      </Paper>
    )
  }

  clearSelectedLayer = () => {
    this.setState({ selectedLayers: [] })
  }

  setSelectedLayer = (event) => {
    const { selectedLayers } = this.state

    // Als laag al geselecteerd is, deselecteer deze
    if (selectedLayers.find(layer => layer === event.target.value)) {
      selectedLayers.forEach((selectedLayer, index) => {
        if (selectedLayer === event.target.value) {
          selectedLayers.splice(index, 1)
        }
      })
    } else {
      selectedLayers.push(event.target.value)
    }

    this.setState({ selectedLayers: selectedLayers })
  }

  clearPublishLayer = () => {
    this.setState({ publishLayers: { low: "", moderate: "", high: "" } })
  }

  setPublishLayer = (key, layer) => {
    const { publishLayers } = this.state
    publishLayers[key] = layer

    this.setState({ publishLayers: publishLayers })
  }

  publishLayers = (low, moderate, high) => {
    const { application } = this.props

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        this.props.dispatch(asyncActions.setLayer("tsws", { appid: 42, low: low, moderate: moderate, high: high }))
          .then(riskSituationLayers => {
            if (riskSituationLayers) {
              // this.clearPublishLayer()
              this.clearSelectedLayer()
              application.appinfo.riskSituationLayers = riskSituationLayers
              this.props.dispatch({ type: actions.SET_APP_INFO, appinfo: application.appinfo })
            }
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
      })
  }

  updateLayer = (event) => {
    const { application } = this.props

    // file name
    const layer = event.target.value

    // low / moderate / high
    const key = event.target.name

    this.setPublishLayer(key, layer)

    const floodRiskLayers = this.state.mapConfig.layers.filter(layer => layer.key !== "Area")
    const floodRiskLayer = floodRiskLayers.find(l => l.key === key)
    const riskSituationLayer = application.appinfo.riskSituationLayers.find(riskSituationLayer => riskSituationLayer.layer === layer)

    if (floodRiskLayer && riskSituationLayer) {
      this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
        .then(() => {
          floodRiskLayer.description = riskSituationLayer.description
          floodRiskLayer.layer = riskSituationLayer.layer
          floodRiskLayer.workspace = riskSituationLayer.workspace
          floodRiskLayer.styles = [riskSituationLayer.styles]

          // Map config overschrijven zodat we de geselecteerde laag op kaart renderen
          this.setState({ mapConfig: this.state.mapConfig }, () => {
            this.props.dispatch(asyncActions.setLoader(this.props.database.loading - 1))
          })
        })
    }
  }

  customContentStateConverter = (contentState) => {
    // changes block type of images to 'atomic'
    // otherwise the WYSIG will not render and/or save image tags
    const newBlockMap = contentState.getBlockMap().map((block) => {
      const entityKey = block.getEntityAt(0)
      if (entityKey !== null) {
        const entityBlock = contentState.getEntity(entityKey)
        const entityType = entityBlock.getType()
        switch (entityType) {
          case "IMAGE": {
            // Het kan voorkomen dat de gebruiker een afbeelding delete maar dat hij toch in de editorstate blijft hangen,
            // in dit geval returnen we het originele block
            if (!entityBlock.data.height && !entityBlock.data.width) {
              return block
            }

            const newBlock = block.merge({
              type: "atomic",
              // text: `![${entityBlock.data.alt}](${entityBlock.data.src})`,
              text: `<img src="${entityBlock.data.src}" alt="${entityBlock.data.alt}" style="height: ${entityBlock.data.height}; width: ${entityBlock.data.width}" />`
            })
            return newBlock
          }
          default:
            return block
        }
      }
      return block
    })
    const newContentState = contentState.set("blockMap", newBlockMap)
    return newContentState
  }

  publishDisclaimer = () => {
    const { firebase } = this.props
    const { editorStateDisclaimer } = this.state

    const that = this

    const uploadUrl = getUploadUrl("tsws")

    let rawContentState = ""
    let key = ""
    let fileName = ""

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + 1))
      .then(() => {
        rawContentState = convertToRaw(editorStateDisclaimer.getCurrentContent())
        key = "DISCLAIMER"
        fileName = "disclaimer.md"

        const html = draftToHtml(rawContentState) // create HTML from the contentState, this saves the image block
        const content = htmlToDraft(html) // create draft from HTML

        const contentState = ContentState.createFromBlockArray(content.contentBlocks, content.entityMap) // create a new contentstate based on the new draft

        const editorState = EditorState.createWithContent(this.customContentStateConverter(contentState)) // use a custom converter that saves the image as markdown
        const rawEditor = convertToRaw(editorState.getCurrentContent())

        const markdownString = draftToMarkdown(rawEditor) // create markdown string from the new content based on the draft from the HTML

        // Disclaimer heeft geen category en zijn orderid is altijd 1
        const parameters = { appid: 42, key: key, category: "", orderid: 1, firebaseProvider: "accra" }

        const headers = [
          { key: "function", value: "myfloodrisk.appfunctions.SetContent" },
          { key: "parameters", value: JSON.stringify(parameters) },
          { key: "uid", value: firebase.userinfo.uid },
          { key: "token", value: firebase.userinfo.token }
        ]

        const file = { value: { name: fileName }, content: markdownString }

        makeRequest("POST", uploadUrl, headers, file, function () {
          // Om er voor te zorgen dat je de melding 'Changes you made may not be saved' niet meer te tonen wanneer je de pagina sluit
          window.onbeforeunload = null

          that.props.dispatch(asyncActions.setLoader(that.props.database.loading - 1))
        })
      })
  }

  publishInfo = () => {
    const { firebase } = this.props
    const { editorStateInfo, infoSlides } = this.state

    const that = this

    const uploadUrl = getUploadUrl("tsws")

    let rawContentState = ""
    let fileName = ""

    this.props.dispatch(asyncActions.setLoader(this.props.database.loading + infoSlides.length))
      .then(() => {
        infoSlides.forEach(slide => {
          rawContentState = convertToRaw(editorStateInfo[slide.key].getCurrentContent())

          fileName = `${slide.key}.json`

          const html = draftToHtml(rawContentState) // create HTML from the contentState, this saves the image block
          const content = htmlToDraft(html) // create draft from HTML

          const contentState = ContentState.createFromBlockArray(content.contentBlocks, content.entityMap) // create a new contentstate based on the new draft
          const editorState = EditorState.createWithContent(this.customContentStateConverter(contentState)) // use a custom converter that saves the image as markdown
          const rawEditor = convertToRaw(editorState.getCurrentContent())

          const markdownString = draftToMarkdown(rawEditor) // create markdown string from the new content based on the draft from the HTML

          const parameters = { appid: 42, key: slide.key, category: slide.category, orderid: slide.orderid, firebaseProvider: "accra" }

          const headers = [
            { key: "function", value: "myfloodrisk.appfunctions.SetContent" },
            { key: "parameters", value: JSON.stringify(parameters) },
            { key: "uid", value: firebase.userinfo.uid },
            { key: "token", value: firebase.userinfo.token }
          ]

          const file = { value: { name: fileName }, content: markdownString }

          makeRequest("POST", uploadUrl, headers, file, function () {
            // Om er voor te zorgen dat je de melding 'Changes you made may not be saved' niet meer te tonen wanneer je de pagina sluit
            window.onbeforeunload = null

            that.props.dispatch(asyncActions.setLoader(that.props.database.loading - 1))
          })
        })
      })
  }

  renderSelectedGeoFiles = () => {
    const { application, classes, t, theme } = this.props
    const { mapConfig, publishLayers } = this.state

    const floodRiskLayers = mapConfig.layers.filter(layer => layer.key !== "Area")
    const layers = application.appinfo.riskSituationLayers

    const publishedLayerNames = []
    Object.keys(publishLayers).forEach(l => {
      publishedLayerNames.push(publishLayers[l])
    })

    return (
      <Paper square style={{ display: "flex", flexDirection: "column", marginTop: theme.spacing(1) }}>
        <Typography variant="h6" className={classes.header}>
          Selected Files
        </Typography>
        <div style={{ padding: theme.spacing(1) }}>
          {floodRiskLayers.map((floodRiskLayer, index) => (
            <div key={index} style={{ marginTop: index === 0 ? 0 : theme.spacing(1) }}>
              <InputLabel>{t(floodRiskLayer.name)}</InputLabel>
              <Select
                value={mapConfig.layers.find(layer => layer.key === floodRiskLayer.key) && mapConfig.layers.find(layer => layer.key === floodRiskLayer.key).layer}
                onChange={(e) => this.updateLayer(e)}
                name={floodRiskLayer.key}
                style={{ width: "100%" }}
                size="small"
              >
                {layers.map((layer, i) => (
                  <MenuItem
                    key={i}
                    value={layer.layer}
                    disabled={publishedLayerNames.includes(layer.layer)}
                  >
                    {layer.name}
                  </MenuItem>
                ))}
              </Select>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "right", padding: theme.spacing(1) }}>
          <Button
            color="primary"
            variant="contained"
            size="small"
            onClick={() => this.handleButtonClick("publishLayers")}
          >
            Publish
          </Button>
        </div>
      </Paper>
    )
  }

  handleStep = (dir) => {
    let activeStep = this.state.activeStep
    activeStep = dir === "next" ? activeStep + 1 : activeStep - 1
    this.setState({ activeStep: activeStep })
  }

  goToStep = (index) => {
    this.setState({ activeStep: index })
  }

  renderUser = () => {
    const { firebase, theme } = this.props

    return (
      <div style={{ display: "flex", alignItems: "flex-end", flexGrow: 1, marginTop: theme.spacing(1) }}>
        <Tooltip title="Logout">
          <div
            style={{ display: "flex", cursor: "pointer" }}
            onMouseEnter={() => this.setState({ userInfoHoverState: true })}
            onMouseLeave={() => this.setState({ userInfoHoverState: false })}
            onClick={() => this.setState({ logoutDialog: { open: true, size: "small" } })}
          >
            {this.state.userInfoHoverState ? <ExitToApp color="primary" /> : <VerifiedUser color="primary" />}
            <Typography style={{ margin: theme.spacing(0.5, 0, 0, 0.5), lineHeight: 1.3 }}>User: {firebase.userinfo.name ? firebase.userinfo.name : firebase.userinfo.email}</Typography>
          </div>
        </Tooltip>
      </div>
    )
  }

  doSignOut = (config, dispatch) => {
    this.closeDialog(config)

    doSignOut(dispatch)
  }

  closeDialog = (config) => {
    config.open = false
    this.setState({ config })
  }

  closeSnackbar = (event, reason) => {
    if (reason === "clickaway") return null

    this.props.dispatch({ type: actions.SET_ERROR, error: null })
  }

  render() {
    const { application, classes, dispatch, firebase, t, theme } = this.props
    const { drawerStates, logoutDialog, removeDialog, viewerType } = this.state

    if (firebase.userinfo.verified !== true) {
      return (
        <div className='App'>
          {this.props.database.loading > 0 && <div className='loader-background'>
            <img src='/static/images/HKV_loader.gif' alt='HKV loader' className='loader-default' />
          </div>}
          {application.error && <Snackbar open={application.error} autoHideDuration={application.error.duration} onClose={this.closeSnackbar} style={{ zIndex: 99999999 }} classes={{ anchorOriginBottomCenter: classes.anchorOriginBottomCenter }}>
            <Alert elevation={6} variant='filled' severity={application.error.type}>
              {t(application.error.message.toString())}
            </Alert>
          </Snackbar>}
          <Login />
        </div>
      )
    }

    // Wanneer er geen appinfo, userinfo of servers zijn gefetched, return null, of een loader wanneer loader aanstaat
    if (!application.appinfo) {
      return this.props.database.loading > 0 ? <div className='loader-background'><img src='/static/images/HKV_loader.gif' alt='HKV loader' className='loader-default' /></div> : null
    }

    const listItems = [
      { name: "Dashboard", value: "dashboard" },
      { name: "Rainfall forecast", value: "forecast" },
      { name: "Literacy information", value: "literacy" },
      { name: "Floodrisk maps", value: "floodriskmaps" },
      { name: "Disclaimer", value: "disclaimer" }
    ]

    return (
      <div className="App">
        {this.props.database.loading > 0 && <div className="loader-background">
          <img src="/static/images/HKV_loader.gif" alt="HKV loader" className="loader-default" />
        </div>}
        {application.error && <Snackbar key={application.error.key} open={application.error ? true : false} autoHideDuration={application.error.duration} onClose={this.closeSnackbar} style={{ zIndex: 99999999 }} classes={{ anchorOriginBottomCenter: classes.anchorOriginBottomCenter }}>
          <Alert elevation={6} variant="filled" severity={application.error.type}>
            {t(application.error.message.toString())}
          </Alert>
        </Snackbar>}
        {/* Vanaf hier eigen componenten */}
        <div className={`${classes.container} ${drawerStates.left ? "moveL" : ""} transition`}>
          {this.renderContent(viewerType)}
        </div>
        <HKVDrawer config={{ placement: "left", title: "MyFloodRisk Accra", toggleButton: false, variant: "persistent", defaultOpen: true, image: "/static/images/logo.png" }} drawerStateChanged={this.drawerStateChanged}>
          <List style={{ display: "flex", flexDirection: "column" }}>
            {listItems.map((listItem, index) => (
              <Paper key={index} square style={{ marginTop: index === 0 ? 0 : theme.spacing(1) }} onClick={() => this.setState({ viewerType: listItem.value })}>
                <ListItem button style={{ fontWeight: viewerType === listItem.value ? 600 : 400 }}>{listItem.name}</ListItem>
              </Paper>
            ))}
          </List>
          {(viewerType === "floodriskmaps" || viewerType === "literacy") && <Divider style={{ margin: theme.spacing(0, 1, 1), background: "rgba(0, 0, 0, 0.25)" }} />}
          {viewerType === "floodriskmaps" && this.renderGeoFiles()}
          {viewerType === "floodriskmaps" && this.renderSelectedGeoFiles()}
          {viewerType === "literacy" && this.renderSlideOrder()}
          {/* {viewerType === "literacy" && this.renderSlideCategory()} */}
          {this.renderUser()}
        </HKVDrawer>
        <HKVDialog config={removeDialog} onClose={this.closeDialog}>
          <DialogTitle>Delete this slide?</DialogTitle>
          <DialogContent>
            <Typography>You will not be able to recover it</Typography>
            <div className="dialog-actions">
              <Button color="primary" variant="contained" className="dialog-button" onClick={() => this.closeDialog(removeDialog)}>
                Cancel
              </Button>
              <Button color="primary" variant="contained" className="dialog-button" onClick={() => this.removeSlide(removeDialog)}>
                Remove
              </Button>
            </div>
          </DialogContent>
        </HKVDialog>
        <HKVDialog config={logoutDialog} onClose={this.closeDialog}>
          <DialogTitle>Are you sure you want to logout?</DialogTitle>
          <DialogContent>
            <div className="dialog-actions">
              <Button color="primary" variant="contained" className="dialog-button" onClick={() => this.closeDialog(logoutDialog)}>
                Cancel
              </Button>
              <Button color="primary" variant="contained" className="dialog-button" onClick={() => this.doSignOut(logoutDialog, dispatch)}>
                Logout
              </Button>
            </div>
          </DialogContent>
        </HKVDialog>
      </div>
    )
  }
}

App = withTranslation("translation")(App)
App = withStyles(styles, { withTheme: true })(App)
export default connect(state => state)(App)
